import React, { useEffect, useRef } from "react";
import { useTranslation, Trans } from "react-i18next";

function Images() {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const globalIndexRef = useRef(0);
  const lastRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const images = containerRef.current.querySelectorAll(".image");

    const activate = (image, x, y) => {
      image.style.left = `${x}px`;
      image.style.top = `${y}px`;
      image.style.zIndex = globalIndexRef.current;
      image.dataset.status = "active";
      lastRef.current = { x, y };
    };

    const distanceFromLast = (x, y) => {
      return Math.hypot(x - lastRef.current.x, y - lastRef.current.y);
    };

    const handleOnMove = (e) => {
      const containerRect = containerRef.current.getBoundingClientRect();
      const x = e.clientX - containerRect.left;
      const y = e.clientY - containerRect.top;

      if (distanceFromLast(x, y) > window.innerWidth / 20) {
        const lead = images[globalIndexRef.current % images.length];
        const tail = images[(globalIndexRef.current - 5) % images.length];

        activate(lead, x, y);
        if (tail) tail.dataset.status = "inactive";

        globalIndexRef.current++;
      }
    };

    const handleTouchMove = (e) => {
      handleOnMove(e.touches[0]);
    };

    window.addEventListener("mousemove", handleOnMove);
    window.addEventListener("touchmove", handleTouchMove);

    return () => {
      window.removeEventListener("mousemove", handleOnMove);
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return (
    <section className="images-container" ref={containerRef} aria-labelledby="images-section">
      <div>
        {Array.from({ length: 13 }).map((_, index) => (
          <img
            key={index}
            className="image"
            data-index={index}
            data-status="inactive"
            src={`/images/playful/${index + 1}.jpg`}
            loading="lazy" 
            alt={`Playful images showing moment ${index + 1}`} 
            aria-hidden={index % 2 === 0 ? "true" : "false"} 
          />
        ))}
      </div>

      <div className="content">
            <img 
            src="/images/icon-touch.svg" 
            className="icon only-mobile" 
            alt="Touch icon for interactive content"
            aria-hidden="true"
            />
            <p className="only-mobile">{t("images.cta")}</p>
            <h3 id="images-section" aria-live="polite">
              <Trans i18nKey="images.title">
                Accelerate your <span className="highlight">path</span> to <span className="highlight">success</span>
              </Trans>
            </h3>
      </div>
    </section>
  );
}

export default Images;
